export default "__VITE_ASSET__y8R0UHQu__"